import { ArrowUp, ArrowDown, Trash2, Plus } from "lucide-react";
import { Panel } from "@/admin/ui";

export default function LessonsEditor({ sections, onChange }) {
  const update = (i, k, v) => onChange(sections.map((s, j) => (j === i ? { ...s, [k]: v } : s)));
  const move = (i, d) => {
    const next = [...sections];
    [next[i], next[i + d]] = [next[i + d], next[i]];
    onChange(next);
  };
  return (
    <Panel title={`Lecciones (${sections.length})`} testid="admin-lessons"
      action={<button className="adm-btn sm" onClick={() => onChange([...sections, { title: "", text: "" }])} data-testid="admin-lesson-add"><Plus size={14} /> Añadir lección</button>}>
      {!sections.length && <div className="adm-empty">Este módulo aún no tiene lecciones.</div>}
      {sections.map((s, i) => (
        <div key={i} className="adm-lesson" data-testid={`admin-lesson-${i}`}>
          <div className="adm-row" style={{ flexWrap: "nowrap", marginBottom: ".6rem" }}>
            <span className="adm-sub" style={{ minWidth: 18 }}>{i + 1}</span>
            <input className="adm-input" placeholder="Título de la lección" value={s.title} onChange={(e) => update(i, "title", e.target.value)} maxLength={160} data-testid={`admin-lesson-title-${i}`} />
            <button className="adm-btn sm" disabled={i === 0} onClick={() => move(i, -1)} aria-label="Subir" data-testid={`admin-lesson-up-${i}`}><ArrowUp size={14} /></button>
            <button className="adm-btn sm" disabled={i === sections.length - 1} onClick={() => move(i, 1)} aria-label="Bajar" data-testid={`admin-lesson-down-${i}`}><ArrowDown size={14} /></button>
            <button className="adm-btn sm danger" onClick={() => onChange(sections.filter((_, j) => j !== i))} aria-label="Eliminar" data-testid={`admin-lesson-delete-${i}`}><Trash2 size={14} /></button>
          </div>
          <textarea className="adm-textarea" placeholder="Escribe una frase por línea" value={s.text} onChange={(e) => update(i, "text", e.target.value)} data-testid={`admin-lesson-text-${i}`} />
        </div>
      ))}
    </Panel>
  );
}
